import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ShowButton
} from "admin-on-rest";
//import find from "lodash.find";
import IconTitle from "../components/icon_title";
import Pagination from "../components/pagination";
import { ActivationActions, ActivationFilter } from "./defaultValues";

const FullNameField = ({ record = {} }) => (
  <span>
    {record.first_name} {record.last_name}
  </span>
);
FullNameField.defaultProps = { label: "Name" };

export const ActivationList = props => {
  return (
    <List
      {...props}
      actions={<ActivationActions />}
      filters={<ActivationFilter />}
      title={
        <IconTitle icon="activation" title={"resources.activation.title"} />
      }
      sort={{ field: "created_at", order: "ASC" }}
      perPage={100}
      pagination={<Pagination />}
    >
      <Datagrid bodyOptions={{ showRowHover: true }}>
        <DateField
          label="resources.activation.field.date"
          source="created_at"
          options={{
            year: "numeric",
            month: "long",
            day: "numeric"
          }}
        />
        <FullNameField
          label="resources.activation.field.name"
          source="first_name"
        />
        <TextField label="resources.activation.field.email" source="email" />
        <TextField label="resources.activation.field.msisdn" source="msisdn" />
        <TextField label="resources.activation.field.status" source="status" />
        <ShowButton label="" style={{ textAlign: "right" }} />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/activations/List.js